const FreshLeaksRoutes = {
  createFreshLeak: "/fresh/createfreshLeaks",
  getAllFreshLeaks: "/fresh/getAllfreshLeaks",
  updateFreshLeak: "/fresh/updateStatus",
  deleteFreshLeak: "/fresh/delete"
}

export default FreshLeaksRoutes;